<script>
import GetEntitiesByForeignKeyId from "./GetEntitiesByForeignKeyId";
import {currencySymbol} from "../../mixins/currency";
import {Money} from 'v-money';

export default {
    props: {
        occasionId: {
            type: Number
        },
        selectedIds: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    components: {
        GetEntitiesByForeignKeyId,
        Money,
    },
    mixins: [currencySymbol],
    data() {
        return {
            participantCount: 0,
            actionType: 'move',
            refundType: 'full',
            amount: 0,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: this.convertCurrencyCodeToPrefix(this.currency),
                suffix: '',
                precision: 2,
                masked: true
            },
        }
    },
    mounted() {
        window.addEventListener('modal_open', () => {
            let actionUrl = `/admin/participants/bulkAction/${this.occasionId}` + window.location.search
            $('#bulkForm').attr('action', actionUrl);
        })

        window.addEventListener('participant_count', (e) => {
            this.participantCount = e.detail.count;
        })
    },
    methods: {
        clear() {
            return this.$emit('clear');
        },
        submitHandler(event) {
            this.$validator.validate().then(valid => {
                if (valid) {
                    event.srcElement.submit();
                }
            });
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .custom-control-label {
    padding-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/ParticipantBulkActionForm.vue